/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetProNumberRequest
 */
export interface SetProNumberRequest {
    /**
     * 
     * @type {string}
     * @memberof SetProNumberRequest
     */
    shipmentId: string;
    /**
     * 
     * @type {string}
     * @memberof SetProNumberRequest
     */
    proNumber: string;
}

/**
 * Check if a given object implements the SetProNumberRequest interface.
 */
export function instanceOfSetProNumberRequest(value: object): value is SetProNumberRequest {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    if (!('proNumber' in value) || value['proNumber'] === undefined) return false;
    return true;
}

export function SetProNumberRequestFromJSON(json: any): SetProNumberRequest {
    return SetProNumberRequestFromJSONTyped(json, false);
}

export function SetProNumberRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetProNumberRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
        'proNumber': json['proNumber'],
    };
}

  export function SetProNumberRequestToJSON(json: any): SetProNumberRequest {
      return SetProNumberRequestToJSONTyped(json, false);
  }

  export function SetProNumberRequestToJSONTyped(value?: SetProNumberRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
        'proNumber': value['proNumber'],
    };
}

